
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ProductImages',
  props: {
    images: Array,
  },
});
